import { render } from "./NotificationItem.vue?vue&type=template&id=77d687c4&scoped=true&ts=true"
import script from "./NotificationItem.vue?vue&type=script&lang=ts"
export * from "./NotificationItem.vue?vue&type=script&lang=ts"

import "./NotificationItem.vue?vue&type=style&index=0&id=77d687c4&lang=css"
import "./NotificationItem.vue?vue&type=style&index=1&id=77d687c4&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d687c4"]])

export default __exports__